import EcografiaAddominaleEdit from "./components/EcografiaAddominaleEdit.vue"
import EcografiaAddominaleView from "./components/EcografiaAddominaleView.vue"
import EcografiaAddominaleList from "./components/EcografiaAddominaleList.vue"

export default {
    EcografiaAddominaleEdit,
    EcografiaAddominaleView,
    EcografiaAddominaleList
}